export default "__VITE_ASSET__a1625963__"